import { render, staticRenderFns } from "./PendingApprovalResult.vue?vue&type=template&id=45a4e58f&scoped=true&"
import script from "./PendingApprovalResult.vue?vue&type=script&lang=ts&"
export * from "./PendingApprovalResult.vue?vue&type=script&lang=ts&"
import style0 from "./PendingApprovalResult.vue?vue&type=style&index=0&id=45a4e58f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4e58f",
  null
  
)

export default component.exports